import React from 'react';
import { PostFullView } from './PostFullView';

type UserProfileMediaProps = {
  posts: any;
};

export function UserProfileMedia({ posts }: UserProfileMediaProps) {
  console.log(posts)
  return (
    <div className="grid grid-cols-3 gap-px">
      {posts.filter((post: any) => post.media.length > 0).map((post: { id: React.Key | null | undefined; media: { type: string; url: string }[] }) => (
        <div key={post.id} className="relative h-0 w-full overflow-hidden bg-neutral-600 pb-[100%]">
          <PostFullView media={post.media} alt={`Post ${post.id}`} />
        </div>
      ))}
    </div>
  );
}
